import { render, staticRenderFns } from "./EventsTemplate.vue?vue&type=template&id=325f61e7&"
import script from "./EventsTemplate.vue?vue&type=script&lang=js&"
export * from "./EventsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EventsTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports